import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://www.visualiseermijnpensioen.nl';
const DEFAULT_IMAGE = `${BASE_URL}/social-preview.jpg`;

const SEOHead = ({ title, description, canonical, image, lang, jsonLd }) => {
	const url = canonical || BASE_URL;
	const img = image || DEFAULT_IMAGE;
	const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

	return (
		<Helmet>
			<html lang={lang || 'nl'} />
			<title>{title}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={url} />

			{/* hreflang — single-URL bilingual site */}
			<link rel="alternate" hreflang="nl" href={url} />
			<link rel="alternate" hreflang="en" href={url} />
			<link rel="alternate" hreflang="x-default" href={url} />

			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={url} />
			<meta property="og:image" content={img} />

			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={img} />

			{schemas.map((schema, i) => (
				<script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
			))}
		</Helmet>
	);
};

export default SEOHead;
